import React, { useState, useEffect } from "react";

import {
    colors,
    Container,
    Grid,
    Hidden,
    makeStyles,
    Paper,
    Slide,
    Typography,
} from "@material-ui/core";

import { useHistory } from "react-router-dom";
import {
    useStylesCAB,
    useStylesContainers,
    useStylesDPM,
    useStylesHed,
    useStylesSpDial,
    useStylesUiElemment,
} from "../../../../../St/comps/UseStyle";
import clsx from "clsx";
import { insh as inshst } from "../../../../../Context/InshSt";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import { insh, sto, wsto } from "../../../../../Context/InshData";
import { useStylesBA } from "../../../../../St/comps/UseStyle";
import { getLS } from "../../../../../utils/useLS";

import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";
import ImportExcel from "../ImportExcel/ImportExcel";
import AddItems from "./addItems";
import axios from "axios";
import { uri } from "../../../../../help/Api";
import toast from "react-hot-toast";
import { BeatLoader } from "react-spinners";
const useStyles = makeStyles((theme) => ({
    root: {
        // backgroundColor: theme.palette.background.dark,
        // paddingBottom: theme.spacing(3),
        // direction: "rtl",
        borderColor: colors.red[300],
        minHeight: "100%",
    },
    input: {
        display: "none",
    },
    imageLogo: {
        marginRight: 20,
        marginTop: 5,
        marginBottom: 10,
        textAlign: "center",
    },
    headerTitle: {
        backgroundColor: colors.red[50],
        textAlign: "center",
        fontSize: 20,
        width: "100%",
        fontWeight: "bold",
        marginBottom: "0.5rem"
    },

    allWidth: {
        minWidth: 650,
    },
    checStyl: {
        marginTop: "17px",
        fontSize: "16px",
        padding: "-1px",
    },
    purchTotalCard: {
        backgroundColor: colors.blue[50],
        borderColor: colors.red[300],
    },

}));
 export function TabsPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box >
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

function TransitionUp(props) {
    return <Slide {...props} direction="up" />;
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}
export default function ItemsMains(props) {
    const { AutoOptions, locat, isDialog, DialogClose } = props;
    const clasess = useStyles();
    const inshParm = { itake: 20, symple: "", groupSearch: null };
    const [value, setValue] = React.useState(0);
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const [excelData, setExcelData] = useState([]);
    const [loadingExcel, setLoadingExcel] = useState(false);

    // ==== b sd

    const his = useHistory();

    const classes = useStyles();
    const { t } = useTranslation(["forms", "translation"]);

    const getFormExcelData = async () => {
        if (excelData.length===0){
            alert(t("no-data"));
            return 0;
        }

        setLoadingExcel(true);
        const header = ["name", "nameE", "barcode", "group_name", "unit_name", "perc", "purch_price", "sale_price", "min_price", "Distributor_price",
            "jomla_price", "beg_date", "end_date", "tax", "discount", "min_val", "safe", "val"];

        const keys = Object.keys(excelData[0]);
        const actiolItems = excelData.map(row => {
            const values = keys.map(k => row[k]);
            const obj = {};
            header.forEach((key, i) => {
                obj[key] = values[i];
            });
            return obj
        });
        const seen = new Set();
        const results = actiolItems.filter(item => {
            if (seen.has(item.barcode)) {
                return false;
            }
            seen.add(item.barcode);
            return true;
        });

        const groups = [...new Set(results.map(item => item.group_name).filter(group => group))];
        const units = [...new Set(results.map(item => item.unit_name).filter(unit => unit))];

        const groupsExcel = groups.map(group => ({ name: group, id: 0 }));
        const unitsExcel = units.map(unit => ({ name: unit, id: 0 }));

        const model = {
            excelItems: results,
            groupsExcel: groupsExcel,
            unitsExcel: unitsExcel,
        };
        axios
            .post(uri + "Groups/addExcelItem", model)
            .then((res) => {
                setExcelData([]);
                setLoadingExcel(false);
                toast.success(t("save-success"));
                setValue(0);
            })
            .catch((error) => {
                console.log(error);
                setLoadingExcel(false);
                toast.error(t("save-failed"));
            });
    };
    return (
        <div className={classes.root}>
            <Typography
                component="div"
                style={{ direction: i18next.language == "ar" ? "rtl" : "ltr" }}
            >
                <Grid
                    container
                    justifyContent="center"
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                >
                    <Grid item lg={12} md={12} sm={12} xs={12} >
                        <div className={clasess.root} style={{ backgroundColor: "fff" }}>
                            <AppBar position="static" style={{ backgroundColor: "fff" }} >
                                <Tabs
                                    style={{ backgroundColor: colors.red[300] }}
                                    value={value}
                                    onChange={handleChange}
                                    aria-label="simple tabs example"
                                >
                                    <Tab style={{ fontWeight: "bold" }} label={t("translation:basic-product-data")}{...a11yProps(0)} />
                                    <Tab style={{ fontWeight: "bold" }} label={t("forms:import-excel")}{...a11yProps(1)} />
                                </Tabs>
                            </AppBar>

                            <TabsPanel value={value} index={0}>
                                {/* <b>{t("forms:foundation-definition")}</b> */}
                                <AddItems
                                    {...{
                                        AutoOptions,
                                        locat,
                                        isDialog,
                                        DialogClose,
                                        fromExcel: true,
                                    }}
                                />
                            </TabsPanel>

                            <TabsPanel value={value} index={1}>
                                <b>{t("forms:import-excel")}</b>
                                <ImportExcel
                                    {...{
                                        isPurches: false,
                                        isStock: false,
                                        isItem: true,
                                        getFormExcelData,
                                        excelData,
                                        setExcelData,
                                        loadingExcel,
                                        setValue
                                    }}
                                />
                            </TabsPanel>
                        </div>
                    </Grid>
                </Grid>

            </Typography>
        </div>
    );
}
